<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-4">
                <card class="border-0 d-flex card-restoran" hover shadow
                  body-classes="text-center align-items-center d-flex justify-content-center">
                  <object data="/img/svg/5-Restaurant.svg" type="image/svg+xml" class="text-white card-pajak"></object>
                  <h6 class="text-white text-uppercase title-inside-card" style="margin-top: 7px">PAJAK RESTORAN</h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Pelayanan Restoran
                  <span>Kabupaten Ketapang</span>
                </h1>
                <p class="description mt-3 text-white">Peraturan Daerah Nomor 11 Tahun 2011, tentang Pajak Restoran</p>

                <p class="description mt-3 text-white">
                  Restoran adalah fasilitas penyedia makan dan/ minuman yang
                  dipungut bayaran, yang mencakup juga rumah makan, kafetaria,
                  kantin, warung, bar, dan sejenisnya termasuk jasa boga/
                  katering.
                </p>
                <p class="description mt-3 text-white">
                  Pajak Restoran dipungut pajak atas pelayanan yang disediakan
                  oleh restoran.
                </p>

                <div class="btn-wrapper">
                  <base-button tag="a" class="mb-3 mb-sm-0" type="info" textColor="white" icon="fa fa-arrow-left"
                    @click="goback()">Kembali</base-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <br>
    <br>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">E-SPTPD</h6>
                  <p class="description mt-3">Pendataan SPTPD Pajak Restoran secara Online.</p>
                  <base-button textColor="white" tag="a" type="success" class="mt-4"
                    @click="goSptpdPajak()">E-SPTPD</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="danger" rounded class="mb-4"></icon>
                  <h6 class="text-danger text-uppercase">Cetak SSPD</h6>
                  <p class="description mt-3">Cetak SSPD Pajak Restoran.</p>
                  <br />
                  <base-button tag="a" textColor="white" type="warning" class="mt-4"
                    @click="cetakSSPD()">Cetak</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-print" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">Informasi Pajak Restoran</h6>
                  <p class="description mt-3">
                    Melihat Informasi Pajak Restoran berdasarkan NPWPD pemilik
                    usaha.
                  </p>
                  <base-button textColor="white" tag="a" type="success" class="mt-4" @click="goPRestoran()">Informasi
                    Pajak</base-button>
                </card>
              </div>
              <div class="col-md-3">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="warning" rounded class="mb-4"></icon>
                  <h6 class="text-warning text-uppercase">Peraturan Pajak Restoran</h6>
                  <p class="description mt-3">
                    Dasar Hukum pemungutan Pajak Restoran yang termuat dalam
                    undang-undang.
                  </p>
                  <base-button tag="a" textColor="white" type="warning" class="mt-4" @click="goDasarHukum()">Dasar
                    Hukum</base-button>
                </card>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </section>
    <modal-informasi-pajak ref="modal-informasi-pajak" title="Pencarian Informasi Pajak Restoran" code="1102"
      url="/api/v1/pajak-daerah/restoran"></modal-informasi-pajak>

    <modal :show.sync="dasar_hukum" footerClasses="text-right" :largeModal="true">
      <h6 slot="header" class="modal-title text-success font-weight-bold" id="modal-title-default">Dasar Hukum Pajak
        Restoran</h6>
      <div class="d-block">
        <div class="elementor-widget-container">
          <p dir="ltr">
            Jika Anda termasuk orang yang sering makan di restoran, pasti sudah
            tidak asing dengan biaya tambahan atau pajak yang tertera dalam
            struk pembelian. Kebanyakan orang mengenali pajak restoran sebagai
            PPN karena tarif yang dikenakan besarnya 10% dari total transaksi.
            Namun, ternyata anggapan tersebut keliru.
          </p>
          <p dir="ltr">
            Jadi, jika pajak restoran itu bukan PPN, lantas termasuk kategori
            pajak apa? Nah, supaya tidak bingung lagi mari simak penjelasannya
            di bawah ini.
          </p>
          <h3 dir="ltr">Pajak Restoran, Pajak Pusat atau Pajak Daerah?</h3>
          <p dir="ltr">
            Pajak restoran dipungut pajak atas pelayanan yang disediakan oleh
            restoran, rumah makan, kafetaria, kantin, warung, dan semacamnya
            termasuk jasa boga/katering.
          </p>
          <p dir="ltr">
            Biasanya ketika makan di restoran, Anda tidak hanya dikenakan pajak
            restoran&nbsp;saja, melainkan ada biaya lain yakni biaya pelayanan
            <em>(service charge)</em>. Umumnya, tarif
            <em>service</em> di
            restoran sebesar 5%.
          </p>
          <p dir="ltr">
            Namun, sebenarnya tarif biaya pelayanan atau
            <em>service</em> setiap
            restoran&nbsp;berbeda-beda. Maksimum pengenaan tarif
            <em>service</em> adalah 10%. Pengenaan tarif
            <em>service</em> ini
            dipungut sebelum pungutan pajak restoran. Maka, jangan heran jika
            Anda makan di restoran, tercantum biaya
            <em>service</em>dan Pajak
            Restoran&nbsp;pada struk.
          </p>
          <p dir="ltr">
            Tarif pajak restoran ditetapkan sebesar 10%. Nah,&nbsp;persentase
            tarif pajak restoran inilah&nbsp;yang membuat banyak orang mengira
            pajak yang dikenakan ketika membeli makanan/minuman di sebuah
            restoran dikategorikan sebagai PPN.
          </p>
          <p dir="ltr">
            Padahal, pajak restoran berbeda dengan PPN. Jika PPN dipungut oleh
            Pemerintah Pusat, dalam hal ini Direktorat Jenderal Pajak (DJP),
            pajak restoran justru dipungut oleh Pemerintah Daerah (Pemda).
            Dahulu, pajak restoran disebut dengan Pajak Bangunan 1 (PB1).
          </p>
          <h3 dir="ltr">Objek dan Subjek Pajak Restoran</h3>
          <p dir="ltr">
            Objek pajak restoran adalah pelayanan yang disediakan oleh rumah
            makan, kafetaria, dan semacamnya. Biasanya, pelayanan yang
            disediakan meliputi pelayanan penjualan makanan/minuman yang dibeli
            atau dikonsumsi oleh pembeli. Baik dikonsumsi di tempat maupun
            dibawa pulang atau dimakan di tempat lain.
          </p>
          <p dir="ltr">
            Selain itu, ada juga yang tidak termasuk dalam objek pajak, yakni
            pelayanan yang disediakan restoran yang pengelolaannya tergabung
            atau menjadi satu manajemennya dengan sebuah hotel. Selain itu,
            pelayanan yang disediakan oleh suatu restoran yang nilai
            penjualannya tidak melebihi Rp 200.000.000/tahun.
          </p>
          <p dir="ltr">
            Sedangkan subjek pajak restoran&nbsp;adalah orang pribadi maupun
            badan yang membeli makanan atau minuman dari suatu restoran atau
            tempat makan yang dikunjungi.
          </p>
          <h3 dir="ltr">
            Biaya/Tarif Pelayanan (
            <em>Service Charge)</em>
          </h3>
          <p dir="ltr">
            Tarif
            <em>service charge</em>biasanya tidak melebihi Pajak
            Restoran. Jadi, rata-rata pengenaan
            <em>service charge</em> sebesar
            5%. Hal yang sama juga diterapkan pada pajak perhotelan. Akan
            tetapi, biasanya
            <em>service charge</em> hotel lebih tinggi dari
            restoran, yakni 10%. Hal ini tergantung kebijakan dari tempat makan
            atau restoran yang terkait.
          </p>
          <p dir="ltr">
            Pada dasarnya, biaya pelayanan atau
            <em>service charge</em> merupakan salah satu dasar dari pengenaan
            Pajak Daerah. Hal tersebut tercantum dalam Peraturan Gubernur
            Provinsi DKI Jakarta No. 92 Tahun 2011 tentang pelaksanaan
            <em>Online System</em>Atas Pelaporan Data Transaksi Usaha Wajib
            Pajak Hotel, Pajak Restoran, Pajak Hiburan, dan Pajak Parkir.
          </p>
          <p dir="ltr">
            Pengenaan
            <em>service charge</em> disesuaikan dengan kebijakan pihak
            restoran, apakah ingin dikenakan atau tidak. Oleh karena itu, Anda
            mungkin sering kali melihat ada beberapa restoran yang memungut
            <em>service charge</em> dan ada juga yang tidak.
          </p>
          <p dir="ltr">
            Bila pelayanan di suatu restoran dikenakan
            <em>service charge</em>,
            maka tagihan
            <em>service charge</em> biasanya akan ditambahkan
            terlebih dahulu pada tagihan belanjaan Anda, sebelum dikenakan pajak
            restoran.
          </p>
          <h3 dir="ltr">Cara Menghitung Pajak Restoran</h3>
          <p dir="ltr">
            Cara menghitung pajak restoran berdasarkan pada pokok pajak restoran
            yang terutang, yakni dengan mengalikan tarif pajak 10% dengan dasar
            pengenaan pajak. Dasar pengenaan pajak merupakan sejumlah bayaran
            yang diterima atau yang seharusnya dipungut oleh restoran.
          </p>
          <p dir="ltr">Contohnya:</p>
          <p dir="ltr">Pajak Restoran: Dasar pengenaan paja x Tarif pajak</p>
          <p dir="ltr">
            Dasar pengenaan pajak (nominal pembayaran yang diterima/dipungut
            sesuai dengan struk atau dokumen lainnya yang sejenis) =
            Rp60.000.000
          </p>
          <p dir="ltr">Tarif pajak = 10%</p>
          <p dir="ltr">Maka, pajak restorannya = Rp60.000.000 x 10% = Rp6.000.000</p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ModalInformasiPajak from "../GlobalPage/InformasiPajak";
import { Chart } from "highcharts-vue";
import axios from "axios";
import Modal from "@/components/Modal.vue";
export default {
  name: "restoran",
  components: {
    ModalInformasiPajak,
    highcharts: Chart,
    Modal,
  },
  data() {
    return {
      items: [],
      dasar_hukum: false,
    };
  },
  computed: {
    checkAkses() {
      if (this.$store.state.auth.status.loggedIn)
        if (this.$store.state.auth.user.is_wajib_pajak)
          return this.$store.state.auth.user.registrations.find((item) => item.business_id == 2)
        else
          return this.$store.state.auth.user.business_id == 2;
      return false;
    },
    chartOptions() {
      return {
        chart: {
          type: "column",
        },
        title: {
          text: "Realisasi Pajak Restoran berdasarkan Tahun",
        },
        subtitle: {
          text: "Data tahun yang di ambil adalah data 10 tahun kebelakang.",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Realisasi",
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.2f}",
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
        },

        series: [
          {
            name: "Tahun",
            colorByPoint: true,
            data: this.items,
          },
        ],
      };
    },
  },
  created() {
    this.getRealisasi();
  },
  methods: {
    async getRealisasi() {
      try {
        this.isBusy = true;
        let { data } = await axios.get("/api/v1/realisasi/restoran");

        var items = [];
        for (const [key, value] of Object.entries(data)) {
          this.items.push({
            name: value.tahun_realisasi,
            y: parseFloat(value.realisasi),
          });
        }
      } catch (error) {
        // console.log(error);
      } finally {
        this.isBusy = false;
      }
    },
    goPRestoran() {
      this.$refs["modal-informasi-pajak"].showModal();
    },
    goWajibPajak() {
      this.$refs["modal-wajib-pajak"].showModal();
    },
    goDasarHukum() {
      this.dasar_hukum = true;
    },
    goback() {
      this.$router.go(-1);
    },
    goWajibPajakInput() {
      this.$router.push("/restoran/daftar");
    },
    goSptpdPajak() {
      this.$router.push("/restoran/e-sptpd");
    },
    cetakSSPD() {
      this.$router.push("/restoran/pembayaran");
    },
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew+.shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-restoran {
  height: 100%;
}
</style>